import PQueue from 'p-queue';

let queue = null;

export default function createQueue() {
	if (!queue) {
		queue = new PQueue({ concurrency: 1 });
	}
	return queue;
}
